import { createNewChatPostFunction, validatePostCreateAt, getIndexChatPostMsg, createNewChatPostWithFilesFunction, getChatPostById, handleSendAiAssistant } from '@/service/chatPostService';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import { uploadFileToS3 } from '@/component/common/UploadFiles';
import Logger from '@/common/utils/Logger';
import { disableAutoScroll } from '@/component/chatThread/handler/FootprintHandler';
import _ from 'lodash';
import { getUserById, getUserDeletedInfor } from '@/service/userService';
import { getProjectById } from '@/service/projectService';
import { I18n, Storage } from 'aws-amplify';
import { cloneDeep } from 'lodash';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { createKibanaDataChat } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { getCorporationById } from '@/service/organizationService';
import { getTicketById, editTicketData } from '@/service/ticketService';
import { getFormById } from '@/service/formManagementService';
import { createThumbnailAPI, uploadImageToS3 } from '@/service/attachFileService';

const TYPE = 'chat';

/**
 * Get delegate user detail
 * @param {*} API 
 * @param {*} chatPostMsg 
 * @param {*} setDelegateUserDetail 
 * @returns
 */
export const getDelegateUserDetail = async (API, chatPostMsg, setDelegateUserDetail) => {
    if (Utils.isEmptyString(chatPostMsg.delegateUserId)) {
        return;
    }
    let userDetail = await getUserById(API, chatPostMsg.delegateUserId);
    userDetail = Utils.isEmptyObject(userDetail) ? {} : userDetail;
    setDelegateUserDetail(userDetail);
};



/**
 * Get delegate detail
 * @param {*} delegateUser 
 * @returns delegateDetail
 */
export const getDelegateDetail = delegateUser => {
    let fullName = `${Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, delegateUser)}`;

    let fullNameByFormat = fullName;
    if (fullName.length > 50) {
        fullNameByFormat = `${fullName.slice(0, 50)}...`;
    }

    return (
        <div>
            <div className="chatBox-sub">
                <p>代理投稿</p>
                <p>ポスター: {fullNameByFormat}</p>
            </div>
        </div>
    );
};


/**
 * validateBeforeSendMsgOnEmailTicketThread
 * @param {*} corporationInfo 
 * @param {*} projectDetail 
 * @param {*} ticketInfoRealtime 
 * @returns 
 */
const validateBeforeSendMsgOnEmailTicketThread = async (corporationInfo, projectDetail, ticketInfoRealtime) => {
    let response = {
        status: true,
        msg: ''
    }

    // Ticket removed phisical
    if (Utils.isEmptyObject(ticketInfoRealtime)) {
        return {
            status: false,
            msg: I18n.get('COMMSG002')
        }
    }

    // Ticket deleted
    if (ticketInfoRealtime?.deletedAt) {
        return {
            status: false,
            msg: I18n.get('MSG-CM-DELETED-TICKET')
        }
    }

    // Ticket archived
    if (ticketInfoRealtime.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED) {
        return {
            status: false,
            msg: I18n.get('MSG-CM-CHANGED-DATA')
        }
    }

    const ticketStatus = Utils.convertJSONDataToObject(ticketInfoRealtime.status)
    // If ticket status is DONE and Changed type to general or Offed email function
    if (
        ticketStatus.value === Constant.STATUS_NO.DONE && (
            Utils.isPublicOffDeskOff(projectDetail) ||
            !Utils.isEnableCreateEmailTicketModeOnSkipProjectType(corporationInfo, projectDetail)
        )
    ) {
        return {
            status: false,
            msg: I18n.get('MSG-CM-CHANGED-DATA')
        };
    }

    // validate realtime status
    let currentStatus = ticketInfoRealtime.status;
    if (currentStatus) {
        currentStatus = Utils.convertJSONDataToObject(currentStatus);
    }

    if (currentStatus?.status) {
        let currentStatusDetail = await getFormById(null, currentStatus?.status);
        if (!Utils.isEmptyObject(currentStatusDetail)) {
            let currentStatusDetailStructure = currentStatusDetail.structure;
            if (currentStatusDetailStructure) {
                currentStatusDetailStructure = Utils.convertJSONDataToObject(currentStatusDetailStructure);

                let isDisableChat = Utils.isDisableEditEmailTicket(ticketInfoRealtime, projectDetail, corporationInfo, currentStatusDetailStructure?.no);
                if (isDisableChat) {
                    return {
                        status: false,
                        msg: I18n.get('MSG-CM-CHANGED-DATA')
                    }; 
                }
            }
        }
    }
    
    return response;
}

export const validateBeforeHandleChatInEmailTicket = async (API, ticketInfo) => {
    const [corporationInfo, projectDetail, ticketInfoRealtime] = await Promise.all([
        getCorporationById(API, ticketInfo.affiliationOrganization),
        getProjectById(API, ticketInfo.affiliationProject),
        getTicketById(API, ticketInfo.id)
    ]);

    let validateData = await validateBeforeSendMsgOnEmailTicketThread(corporationInfo, projectDetail, ticketInfoRealtime)
    return validateData
}

const checkTriggerAssistantMessage = (ticketInfo, selectThread, deliverInfo, projectInuseId) =>{
    if(deliverInfo?.status === Constant.DELIVER_STATUS.UNDELIVER){
        return false
    }
    // Agent phía desk gửi message vào customer thread thì không trigger assistant
    // Exception: voice call project-to-project — both sides are agents, caller is also "desk"
    // but should still trigger AI Assistant when chatting in customer thread
    const isVoiceCallProjectToProject = ticketInfo.ticketType === Constant.TICKET_TYPE.TELEPHONE &&
        Utils.defineVoiceCallFlow(ticketInfo?.metaData) === TelephoneConstant.VOICE_CALL_FLOW.PROJECT_TO_PROJECT;
    let isDesk = projectInuseId === ticketInfo.affiliationProject;
    if (isDesk && selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER && !isVoiceCallProjectToProject) {
        return false;
    }
    let isTelephoneTicketMessgae = ticketInfo.ticketType === Constant.TICKET_TYPE.TELEPHONE && (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER || selectThread.threadType === Constant.THREAD_TYPE.AI_ASSISTANT);

    return isTelephoneTicketMessgae
}


/**
 * Handle submit msg
 * @param {*} params
 * @returns msg
 */
export const onSubmitCreateMsg = async ({
    setIsCreateNewMsg,
    isDelegateThread,
    isPostCreatedAtCurrentTime,
    postCreatedAtDateTime,
    ticketInfo,
    setMessageError,
    corporationId,
    userDetail,
    userDelegateCreateTicketDetail,
    chatThreadId,
    setChatPostAllList,
    API,
    setChatPostInsertFail,
    setChatPostUpdate,
    txtChatPostRef,
    selectedProjectId,
    contentPost,
    mentionsList,
    selectThread,
    corporationDetail,
    projectInuseDetail,
    isDeliver,
    setCreateMsgErr,
    setIsLoading,
    setLastedSendMsgIdState,
    setIsDeliver,
    statusSend,
    isSentMessage,
    uploadFiles,
    setUploadedFiles,
    setIdMessageRendering
}) => {
    const isChatInTicketEmailCustomerThread = ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL && selectThread?.threadType === Constant.THREAD_TYPE.CUSTOMER;
    const isCustomerThreadChat = ticketInfo?.ticketType !== Constant.TICKET_TYPE.EMAIL && (selectThread?.threadType === Constant.THREAD_TYPE.CUSTOMER || selectThread?.threadType === Constant.THREAD_TYPE.ESCALATION)

    if (isChatInTicketEmailCustomerThread) {
        if (setIsLoading) {
            setIsLoading(true);
        }
    }

    // disable auto scroll
    disableAutoScroll(true);
    // set is create new msg
    setIsCreateNewMsg(true);
    let affiliationProject = selectedProjectId;

    let dataValidate = {
        isDelegateThread: isDelegateThread,
        isPostCreatedAtCurrentTime: isPostCreatedAtCurrentTime,
        postCreatedAtDateTime: postCreatedAtDateTime,
        ticketCreatedAt: ticketInfo.createdAt,
    };
    let valid = validatePostCreateAt(dataValidate);
    if (!Utils.isEmptyString(valid.message)) {
        setMessageError(valid.message);
        return false;
    }
    let creatorId = userDetail.id;
    let delegateUserId = null;

    // get user detail of post msg
    let userDetailPostMsg = userDetail;
    if (isDelegateThread) {
        delegateUserId = userDetail.id;
        creatorId = userDelegateCreateTicketDetail
            ? userDelegateCreateTicketDetail.id
            : userDetail.id;
        affiliationProject = userDelegateCreateTicketDetail?.affiliationProject ? userDelegateCreateTicketDetail?.affiliationProject : ''
        if (typeof affiliationProject != 'string' && affiliationProject?.length > 0) affiliationProject = affiliationProject[0];
        // get user detail of post msg
        userDetailPostMsg = userDelegateCreateTicketDetail;
    }
    
    try {
        console.log('ticketInfo.ticketType :>> ', ticketInfo.ticketType, selectThread);
        // Validate before send chat in email ticket thread chat 
        if (ticketInfo.ticketType === Constant.TICKET_TYPE.EMAIL) {
            // as of now, apply richtext for customer thread, so we don't need escape html characters in here
            if(selectThread.threadType !== Constant.THREAD_TYPE.CUSTOMER)
                contentPost = Utils.escapeHtmlCharacters(contentPost);
            
            let validateData = await validateBeforeHandleChatInEmailTicket(API, ticketInfo)
            if (!validateData.status) {
                if (setCreateMsgErr) {
                    setCreateMsgErr({ isShow : true, msg: validateData.msg ? validateData.msg : I18n.get('MSG-CM-CHANGED-DATA') });
                }
                return false;
            }
        }

        let currentTime = new Date();
        let createdAt = valid.data || null;
        
        mentionsList = !Utils.isEmptyArray(mentionsList) ? [...new Set(mentionsList)] : [];

        let inputChatPost = {
            createNewChatPostRequestDto: {
                ticketAffiliationOrganization: ticketInfo?.affiliationOrganization ? ticketInfo?.affiliationOrganization : corporationId,
                ticketAffiliationProject: ticketInfo?.affiliationProject ? ticketInfo?.affiliationProject : affiliationProject,
                corporationId: corporationId,
                postType: Utils.isEmptyArray(uploadFiles)
                    ? Constant.POST_TYPE.MSG
                    : Constant.POST_TYPE.MSG_FILES,
                chatThreadId: chatThreadId,
                content: contentPost,
                creatorId: creatorId,
                delegateUserId: delegateUserId,
                affiliationProject: affiliationProject,
                status: Constant.CHAT_POST_STATUS.UN_READ,
                seq: currentTime.getTime() + '',
                mention: mentionsList,
                ticketId: ticketInfo.id
            },
            dataFiles: {
                uploadFiles,
                userDetail,
                selectThread
            }
        };

        if (createdAt) {
            inputChatPost = {
                ...inputChatPost,
                createNewChatPostRequestDto: {
                    ...inputChatPost.createNewChatPostRequestDto,
                    createdAt: createdAt
                }
            };
        }
        if (statusSend) {
            inputChatPost = {
                ...inputChatPost,
                createNewChatPostRequestDto: {
                    ...inputChatPost.createNewChatPostRequestDto,
                    statusUpdateForTicket: statusSend,
                    isSentMessage: isSentMessage
                }
            };
        }
        if (isChatInTicketEmailCustomerThread) {
            let deliverInfo = {
                status: isDeliver ? Constant.DELIVER_STATUS.DELIVER : Constant.DELIVER_STATUS.UNDELIVER,
                deliverAt: isDeliver ? new Date().toISOString() : null,
                sender: isDeliver ? creatorId : '',
            }
            inputChatPost = {
                ...inputChatPost,
                createNewChatPostRequestDto: {
                    ...inputChatPost.createNewChatPostRequestDto,
                    deliverInfo
                }
            };
        };

        if (isCustomerThreadChat) {
            let deliverAt = isSentMessage ? new Date().toISOString() : null;
            if (valid?.data) {
                deliverAt = valid.data;
                inputChatPost.createNewChatPostRequestDto.updatedAt = valid.data;
            }
            let deliverInfo = {
                status: isSentMessage
                    ? Constant.DELIVER_STATUS.DELIVER
                    : Constant.DELIVER_STATUS.UNDELIVER,
                deliverAt: deliverAt,
                sender: isSentMessage ? creatorId : ''
            };

            if (!isSentMessage) {
                inputChatPost.createNewChatPostRequestDto.affiliationProject =
                    inputChatPost.createNewChatPostRequestDto.ticketAffiliationProject;
            }

            inputChatPost = {
                ...inputChatPost,
                createNewChatPostRequestDto: {
                    ...inputChatPost.createNewChatPostRequestDto,
                    deliverInfo
                }
            };
        }
        if (setIsDeliver) {
            setIsDeliver(false);
        }

        let isAiAssistantThread = selectThread.threadType === Constant.THREAD_TYPE.AI_ASSISTANT
        let isTriggerAssistantMessage = checkTriggerAssistantMessage(ticketInfo, selectThread, inputChatPost.createNewChatPostRequestDto.deliverInfo, projectInuseDetail.id)
        setMessageError('');
        createNewChatPostWithFilesFunction(inputChatPost, {setIdMessageRendering: setIdMessageRendering, isTriggerAssistantMessage: isTriggerAssistantMessage,projectInuseId: projectInuseDetail.id, isAiAssistantThread, ticketInfo})
            .then(async (post) => {
                if (post != null) {
                    if (setLastedSendMsgIdState && isChatInTicketEmailCustomerThread) {
                        setLastedSendMsgIdState(post.id);
                    }
                    if (isChatInTicketEmailCustomerThread) {
                        if (setIsLoading) {
                            setIsLoading(false);
                        }
                    }

                    setChatPostAllList({
                        type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.PUSH,
                        post: {
                            ...inputChatPost.createNewChatPostRequestDto,
                            userDetailPostMsg: userDetailPostMsg,
                            createdAt: post.createdAt
                        },
                    });

                    post.userDetailPostMsg = userDetailPostMsg;
                    if (!Utils.isEmptyObject(post)) {
                        setChatPostUpdate(post);
                        
                        if (!Utils.isEmptyArray(uploadFiles)) {
                            setUploadedFiles(prev => {
                                return {
                                    ...prev,
                                    [post.id]: uploadFiles
                                };
                            });

                            let count = 0;
    
                            do {
                                await new Promise(resolve => setTimeout(resolve, 1000));
                                const chatPost = await getChatPostById(null, post.id);
                                const attachFiles = Utils.convertJSONDataToObject(
                                    chatPost?.attachFiles
                                );
                                if (
                                    !Utils.isEmptyArray(attachFiles) &&
                                    uploadFiles?.every(f =>
                                        attachFiles.find(
                                            file => file?.fileInfo?.fileName === f?.fileData?.name
                                        )
                                    )
                                ) {
                                    setUploadedFiles(prev => {
                                        return {
                                            ...prev,
                                            [chatPost.id]: uploadFiles.map(i => {
                                                const attachFile = attachFiles.find(
                                                    file =>
                                                        file.fileInfo.fileName === i.fileData.name
                                                );
                                                return {
                                                    ...i,
                                                    ...attachFile
                                                };
                                            })
                                        };
                                    });
                                    break;
                                } else {
                                    count++;
                                }
                            } while (count < 10);
                        }

                        let isLogKibana = isLogKibanaByChat(ticketInfo, selectThread, projectInuseDetail, inputChatPost?.createNewChatPostRequestDto?.deliverInfo);
                        if (isLogKibana) {
                            createKibanaDataChat(
                                selectThread,
                                API,
                                corporationDetail,
                                projectInuseDetail,
                                userDetail,
                                ticketInfo
                            );
                        }
                    }
                } else {
                    setChatPostInsertFail({
                        status: false,
                        data: {
                            ...inputChatPost.createNewChatPostRequestDto,
                            userDetailPostMsg: userDetailPostMsg
                        },
                    });

                    if (isChatInTicketEmailCustomerThread) {
                        if (setIsLoading) {
                            setIsLoading(false);
                        }
                    }
                }
            })
            .finally(() => {
                if (setIsLoading) {
                    setIsLoading(false);
                }
            });

            if (isChatInTicketEmailCustomerThread) {
                if (setIsLoading) {
                    setIsLoading(false);
                }
            }
        return true
    } catch (error) {
        console.log('exception handleOnKeyPress enter', error);
    }
};

export const onResendMessage = async (API, inputChatPost, userDetail, setChatPostUpdate, setChatPostInsertFail) => {
    createNewChatPostFunction(API, inputChatPost)
        .then((post) => {
            if (!Utils.isEmptyObject(post)) {
                post.userDetailPostMsg = userDetail;
                Logger.info(`createNewChatPost - chatPost msg new:`, post);
                if (!Utils.isEmptyObject(post)) {
                    setChatPostUpdate(post);
                }
            } else {
                Logger.info(`createNewChatPost - fail !`);
                setChatPostInsertFail({
                    status: false,
                    data: {
                        ...inputChatPost.createNewChatPostRequestDto,
                        userDetailPostMsg: userDetail
                    },
                });
            }
        })
}

export const createChatPostFile = async (API, createNewChatPostRequestDto) => {
    try {
        let inputChatPost = {
            createNewChatPostRequestDto: createNewChatPostRequestDto,
        };

        let post = await createNewChatPostFunction(API, inputChatPost);
        if (post != null) {
            Logger.info(`post:`, post);
            // set msg images
        }
    } catch (error) {
        console.log('exception handleOnKeyPress enter', error);
    }
};

/**
 * 
 * @param {*} API 
 * @param {*} corporationId 
 * @param {*} post 
 * @param {*} chatPostAllList 
 * @param {*} setChatPostAllList 
 * @param {*} fileUploadedList 
 * @param {*} setFileUploadedList 
 * @param {*} isDataChanged 
 * @param {*} setIsDataChanged 
 * @param {*} userDetail 
 * @param {*} userChatList 
 * @param {*} setUserChatList 
 */
export const addChatPostToList = (
    API,
    corporationId,
    post,
    chatPostAllList,
    setChatPostAllList,
    fileUploadedList,
    setFileUploadedList,
    isDataChanged,
    setIsDataChanged,
    userDetail,
    userChatList,
    setUserChatList
) => {
    updateUserDetailPostMsg(API, post, userChatList, setUserChatList).then(() => {
    if ((post.postType !== Constant.POST_TYPE.MSG && post.postType !== Constant.POST_TYPE.MSG_FILES) && !Utils.isEmptyString(post.fileUrl)) {
        let fileUploadInfor = _.find(chatPostAllList, ['fileUrl', post.fileUrl]);
        if (typeof fileUploadInfor !== 'undefined') {
            let fileUploadIndex = chatPostAllList.indexOf(fileUploadInfor);
            setChatPostAllList({
                type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.REPLACE,
                newPost: post,
                postIndex: fileUploadIndex,
            });
            if (fileUploadedList.length > 0) {
                let newFileUploadedList = JSON.parse(JSON.stringify(fileUploadedList));
                _.remove(newFileUploadedList, function (file) {
                    return post.fileUrl === file.key;
                });
                setFileUploadedList(newFileUploadedList);
            }
            setIsDataChanged(!isDataChanged);
            return;
        }
    }
    if (
        (post.postType === Constant.POST_TYPE.MSG || post.postType === Constant.POST_TYPE.MSG_FILES) &&
        (post.creatorId === userDetail.id || post.delegateUserId === userDetail.id) &&
        post.corporationId === corporationId
    ) {
        let msgIndex = getIndexChatPostMsg(chatPostAllList, post);
        if (msgIndex >= 0) {
            setChatPostAllList({
                type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.REPLACE,
                newPost: post,
                postIndex: msgIndex,
            });
            setIsDataChanged(!isDataChanged);
            return;
        }
    }
    setChatPostAllList({
        type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.PUSH,
        post: post,
    });
    setIsDataChanged(!isDataChanged);
    });
};

/**
 *
 * @param {*} post
 * @param {*} chatPostAllList
 * @param {*} setChatPostAllList
 * @param {*} isDataChanged
 * @param {*} setIsDataChanged
 */
export const deleteChatPostToList = (
    post,
    chatPostAllList,
    setChatPostAllList,
    isDataChanged,
    setIsDataChanged
) => {
    // delete msg
    let findById = true;
    let msgIndex = getIndexChatPostMsg(chatPostAllList, post, findById);
    if (msgIndex >= 0) {
        let chatPostAllListNew = [...chatPostAllList];
        chatPostAllListNew.splice(msgIndex, 1);
        setChatPostAllList({
            type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.INITIAL,
            posts: chatPostAllListNew ? chatPostAllListNew : [],
        });
        setIsDataChanged(!isDataChanged);
    }
};

/**
 *
 * @param {*} post
 * @param {*} chatPostAllList
 * @param {*} setChatPostAllList
 * @param {*} isDataChanged
 * @param {*} setIsDataChanged
 */
export const updateChatPostToList = (
    post,
    chatPostAllList,
    setChatPostAllList,
    isDataChanged,
    setIsDataChanged
) => {
    let findById = true;
    let msgIndex = getIndexChatPostMsg(chatPostAllList, post, findById);
    if (msgIndex >= 0) {
        setChatPostAllList({
            type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.REPLACE,
            newPost: post,
            postIndex: msgIndex,
        });
        setIsDataChanged(!isDataChanged);
    }
};



/**
 * Is push delegate post msg
 * isPush: delegate thread, customer thread
 * @param {*} isEnableChat 
 * @param {*} selectThread 
 * @param {*} ticketListType 
 * @param {*} ticketInfo
 * @param {*} escalationThread
 * @returns isPushDelegatePostMsg
 */
export const isPushDelegatePostMsg = (isEnableChat, selectThread, panelType, ticketInfo, escalationThread) => {
    if (ticketInfo?.anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT) {
        return false
    }

    if (
        ticketInfo.ticketType === Constant.TICKET_TYPE.EMAIL ||
        ticketInfo.ticketType === Constant.TICKET_TYPE.TELEPHONE
    ) {
        return false;
    }


    // read id from escalation thread list
    let escalationThreadIdList = escalationThread.map(item => {
        return item['id'];
    });
     return isEnableChat && (
        Constant.THREAD_TYPE.CUSTOMER === selectThread.threadType ||
        (Constant.TICKET_TYPE.ESCALATION === ticketInfo.ticketType && Constant.THREAD_TYPE.ESCALATION === selectThread.threadType)
    )
        && panelType.includes(Constant.TYPE_GET_TICKET_LIST.HELPDESK) 
        && !escalationThreadIdList.includes(selectThread.id)
        && ![
            Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT,
            Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT,
            // check notice ticket
            Constant.TICKET_TYPE.BROADCAST_PARENT,
            Constant.TICKET_TYPE.BROADCAST_CHILD,
            Constant.TICKET_TYPE.NOTICE
        ].includes(ticketInfo.ticketType); 
};



/**
 * Check disable user list delegate msg
 * @param {*} ticketInfo 
 */
export const checkDisableUserListDelegateMsg = async args => {
    let isDisable = true;
    try {
        let projectOrigin = args.ticketDetailSelected.projectOrigin;
        if (projectOrigin === Constant.ANONYMOUS_USER_ID) {
            return args.setIsDisableUserListDelegateMsg(false)
        }
        let project = await getProjectById(args.API, args.ticketDetailSelected.projectOrigin);

        // disable if project is: customer or base project
        isDisable = !Utils.isEmptyObject(project) &&
            (Utils.isEmptyArray(args.userGuestList)
                || Constant.PROJECT_TYPE.BASE === project.type
                || Constant.PROJECT_TYPE.CUSTOMER === project.type
                // disable if project only PM
                || (args.userGuestList.length === 1 && args.userGuestList[0].id === args.userDelegateCreateTicketDetail.id)
            );
    } catch (err) {
        console.error('isDisableUserListDelegateMsg error: ', err);
        isDisable = false;
    }
    args.setIsDisableUserListDelegateMsg(isDisable);
};

export const getInfomationChatPostList = (allThread,chatPostList) => {
    let chatPostListUpdate = chatPostList.map((item, index) => {
        if(item.chatThreadId === allThread.customerThread?.id) {
            return {
                ...item,
                colorChatThread: allThread.customerThread?.colorChatThread,
                colorTabThread: allThread.customerThread?.colorTabThread,
                threadName: I18n.get('USER07BTN006')
            }
        }

        if(item.chatThreadId === allThread.internalThread?.id) {
            return {
                ...item,
                colorChatThread: allThread.internalThread?.colorChatThread,
                colorTabThread: allThread.internalThread?.colorTabThread,
                threadName: I18n.get('USER07BTN007')
            }
        }

        if(item.chatThreadId === allThread.customerReferenceThread?.id) {
            return {
                ...item,
                colorChatThread: allThread.customerReferenceThread?.colorChatThread,
                colorTabThread: allThread.customerReferenceThread?.colorTabThread,
                threadName: I18n.get('USER07BTN005')
            }
        }

        if(item.chatThreadId === allThread.aiAssistantThread?.id) {
            return {
                ...item,
                colorChatThread: allThread.aiAssistantThread?.colorChatThread,
                colorTabThread: allThread.aiAssistantThread?.colorTabThread,
                threadName: I18n.get('AI_ASSISTANT')
            }
        }

        let escalateThread =  cloneDeep(allThread.escalationThread);

        let indexEscalate  = Utils.findIndexInArrayById(item.chatThreadId, escalateThread);
        return {
            ...item,
            colorChatThread: Constant.COLOR_THREAD_CHAT.ESCALATE_CHAT,
            colorTabThread: Constant.COLOR_THREAD_CHAT.ESCALATE_TAB,
            threadName: escalateThread[indexEscalate]?.projectName
        }
    })

    return chatPostListUpdate;
}

/**
 * 
 * @param {*} API 
 * @param {*} post 
 * @param {*} userChatList 
 * @param {*} setUserChatList 
 */
const updateUserDetailPostMsg = async (API, post, userChatList, setUserChatList) => {
    let userDetailPostMsg = _.find(userChatList, ['id', post.creatorId]);

    if (Utils.isEmptyObject(userDetailPostMsg) || !userDetailPostMsg.avatar) {
        userDetailPostMsg = await getUserById(API, post.creatorId);

        if (Utils.isEmptyObject(userDetailPostMsg)) {
            userDetailPostMsg = getUserDeletedInfor(post.creatorId);
        }
        if(userDetailPostMsg?.image){
            userDetailPostMsg.avatar = await Storage.get(userDetailPostMsg?.image);
        }else{
            userDetailPostMsg.avatar = Constant.AVATAR_DEFAULT
        }
        
        userChatList.push(userDetailPostMsg);
    }

    // update id for anonymous user
    if(Utils.isEmptyString(userDetailPostMsg.id) && post.creatorId?.includes('anonymous_')){
        userDetailPostMsg.id = post.creatorId;
    }
    post.userDetailPostMsg = userDetailPostMsg;

    //get mention list detail
    if(!Utils.isEmptyArray(post.mention)) {
        let listMentionDetail = await Promise.all(post.mention?.map(userId => {
            let userMentionDetail = userChatList.find(user => user.id === userId)
            if(Utils.isEmptyObject(userMentionDetail)) {
                return getUserById(API, userId);
            } else {
                return userMentionDetail;
            }
        }))
        userChatList = [...userChatList, ...listMentionDetail]
    }

    setUserChatList(userChatList);
};

/**
 * 
 * @param {*} ticketInfo 
 * @param {*} selectThread 
 */
export const isEmailTicketCustomerChatthread = (ticketInfo, selectThread) => {
    return (ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL) && 
        (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER)
}

/**
 * 
 * @param {*} ticketInfo 
 * @param {*} selectThread 
 * @param {*} currentPost
 */
 export const isEmailMessUndeliver = (ticketInfo, selectThread, currentPost) => {
    if (![Constant.TICKET_TYPE.EMAIL, Constant.TICKET_TYPE.EMAIL_REPLY].includes(ticketInfo?.ticketType)) return false;

    if (selectThread.threadType !== Constant.THREAD_TYPE.CUSTOMER) return false;
    
    return !currentPost?.deliverInfo?.status;
}

/**
 * 
 * @param {*} ticketInfo 
 */
 export const isEmailTicket = (ticketInfo, selectThread) => {
    return (ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL)
}


/**
 * deliverMsg
 * @param {*} chatPostId 
 * @param {*} ticketId 
 * @param {*} userDetail 
 * @param {*} setIsLoading 
 * @param {*} setIsOpenModalReloadPage 
 * @returns 
 */
export const deliverEmailMsg = async (
    chatPostId,
    ticketId,
    userDetail,
    setIsLoading,
    setIsOpenModalReloadPage,
    reloadTicketDetail,

    dataForLog
) => {
    setIsLoading(true);
    await Utils.delay(1000);
    let updateData = {
        currentUserMail: userDetail?.mail,
        corporationId: userDetail?.affiliationOrganization,
        ticketType: Constant.TICKET_TYPE.EMAIL,
        ticketId: ticketId,
        currentUserId: userDetail?.id,
        chatPostId: chatPostId,
        updateMethod: Constant.UPDATE_TICKET_METHOD.DELIVER_REPLY_EMAIL_TICKET
    };
    const delieverResponse = await editTicketData(null, updateData);

    if (delieverResponse?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
        setIsLoading(false);
        setIsOpenModalReloadPage(true);
        return;
    }
    let deliverInfo = {
        status: Constant.DELIVER_STATUS.DELIVER
    }
    let isLogKibana = isLogKibanaByChat(dataForLog.ticketInfo, dataForLog.selectThread, dataForLog.projectInuseDetail, deliverInfo);
    if (isLogKibana) {
        createKibanaDataChat(
            dataForLog.selectThread,
            dataForLog.API,
            dataForLog.corporationDetail,
            dataForLog.projectInuseDetail,
            userDetail,
            dataForLog.ticketInfo
        );
    }

    reloadTicketDetail();

    setIsLoading(false);
};

export const deliverMsg = async (
    chatPostId,
    ticketId,
    userDetail,
    funcstionParams,
    ticketInfo,
    dataForLog,
    post,
    selectThread,
    setIdMessageRendering
) => {
    funcstionParams?.setIsLoading(true);
    await Utils.delay(1000);
    let updateData = {
        currentUserMail: userDetail?.mail,
        corporationId: userDetail?.affiliationOrganization,
        ticketId: ticketId,
        currentUserId: userDetail?.id,
        chatPostId: chatPostId,
        ticketType: ticketInfo.ticketType,
        updateMethod: Constant.UPDATE_TICKET_METHOD.DELIVER_UNSENT_MESSAGE
    };
    const delieverResponse = await editTicketData(null, updateData);

    if (delieverResponse?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
        funcstionParams?.setIsLoading(false);
        funcstionParams?.setIsOpenModalReloadPage(true);
        return;
    }
    let deliverInfo = {
        status: Constant.DELIVER_STATUS.DELIVER
    };

    let isTriggerAssistantMessage = checkTriggerAssistantMessage(
        ticketInfo,
        selectThread,
        {status : Constant.DELIVER_STATUS.DELIVER},
        funcstionParams?.projectInuseDetail?.id
    );

    if (isTriggerAssistantMessage) {
        handleSendAiAssistant(post, ticketInfo, setIdMessageRendering, false, funcstionParams?.projectInuseDetail?.id);
    }

    let isLogKibana = isLogKibanaByChat(
        dataForLog.ticketInfo,
        dataForLog.selectThread,
        dataForLog.projectInuseDetail,
        deliverInfo
    );
    if (isLogKibana) {
        createKibanaDataChat(
            dataForLog.selectThread,
            dataForLog.API,
            dataForLog.corporationDetail,
            dataForLog.projectInuseDetail,
            userDetail,
            dataForLog.ticketInfo
        );
    }

    funcstionParams?.reloadTicketDetail();

    funcstionParams?.setIsLoading(false);
};

const isLogKibanaByChat = (ticketDetail, threadDetail, projectInuseDetail, deliverInfo) => {
    const ticketType = ticketDetail?.ticketType;
    const threadType = threadDetail?.threadType;

    const isTicketQAOrNotice = [
        Constant.TICKET_TYPE.QA,
        Constant.TICKET_TYPE.INTERNAL_QA,
        Constant.TICKET_TYPE.EXTERNAL_QA,
        Constant.TICKET_TYPE.ESCALATION,
        Constant.TICKET_TYPE.DELEGATE,
        Constant.TICKET_TYPE.NOTICE,
        Constant.TICKET_TYPE.BROADCAST_PARENT,
        Constant.TICKET_TYPE.BROADCAST_CHILD
    ].includes(ticketType);

    if (!isTicketQAOrNotice) return true;

    const isCustomerChatThread = threadType === Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD;
    const isEscalateChatThread = threadType === Constant.THREAD_CHAT_TYPE.ESCALATION_THREAD;

    if (!isCustomerChatThread && !isEscalateChatThread) return true;

    const isTicketInProject = projectInuseDetail?.id === ticketDetail?.affiliationProject;
    if (!isTicketInProject) return true;

    return deliverInfo?.status === Constant.DELIVER_STATUS.DELIVER;
};

export const createTmpUploadedFiles = async ({
    corporationId,
    projectInuseId,
    chatThreadId,
    files,
    setUploadFiles,
    setIsUploading
}) => {
    setIsUploading(true);
    try {
        const path = `tmp/${corporationId}/${projectInuseId}/${chatThreadId}`;
        const listImgData = await uploadFilesTmp(path, files);

        if (!Utils.isEmptyArray(listImgData)) {
            setUploadFiles(prev => {
                return prev.map(file => {
                    const match = listImgData.find(item => item.file.id === file.id);
                    if (match) {
                        return {
                            ...file,
                            s3Path: match.file.s3Path,
                            thumbnailInfo: match.thumbnailInfo
                        };
                    }
                    return file;
                });
            });
        }
    } catch (error) {
        console.log('createTmpUploadedFiles error :', error);
    }
    setIsUploading(false);
};

export const uploadFilesTmp = async (path, listImage) => {
    if (Utils.isEmptyArray(listImage)) return;

    const putImageS3 = await Promise.all(
        listImage.map(async file => {
            const uploaded = await uploadImageToS3(path, file.fileData);
            return {
                id: file?.id,
                s3Path: uploaded
            };
        })
    );

    const thumbnailData = await createThumbnail(
        putImageS3.filter(data => Boolean(data)),
        Constant.CREATE_THUMBNAIL_ACTION_TYPE.CREATE_THUMBNAIL_FOR_TMP_IMG
    );
    return thumbnailData;
};

export const createThumbnail = async (fileList, actionType) => {
    if (Utils.isEmptyArray(fileList)) return;
    const queryParams = {
        actionType,
        fileList: fileList.map(file => JSON.stringify(file)),
        attachBy: Constant.ATTACH_FILE.ATTACH_BY.CHAT
    };
    const response = await createThumbnailAPI(queryParams);
    if (!response || Number(response.statusCode) !== 200) {
        return [];
    }

    return Utils.convertJSONDataToObject(response.body);
};
